const acDetailedRateCard = {
  title: "AC Detailed Rate Card",
  note:
    "Labour charges, inspection fees, spare parts, and platform pricing must remain transparent. Final quote may vary by model, part brand, site condition, urgency, and service complexity. Avoid overpricing, but keep enough margin for worker fairness, support operations, reassignment risk, and platform sustainability.",
  sections: [
    {
      title: "Core Services",
      items: [
        { name: "Lite AC Service", price: "₹499" },
        { name: "Foam-jet AC Service", price: "₹599" },
        { name: "AC Installation", price: "₹1699 onwards" },
        { name: "AC Uninstallation", price: "₹699" },
        { name: "Not Cooling Inspection", price: "₹299" },
        { name: "Water Leakage Inspection", price: "₹299" },
      ],
    },
    {
      title: "Minor Repairs",
      items: [
        { name: "Drain Pipe Adjustment", price: "₹100 + labour if applicable" },
        { name: "Insulation Refix", price: "₹399 labour" },
        { name: "Noise Adjustment", price: "₹399 labour" },
        { name: "Basic Connector / Small Wire Fix", price: "₹100-₹150 + labour" },
      ],
    },
    {
      title: "Electrical Parts",
      items: [
        { name: "Capacitor Change", price: "₹250-₹500 + labour" },
        { name: "Sensor Replacement", price: "₹350 + labour" },
        { name: "Contactor Replacement", price: "₹500 + labour" },
        { name: "PCB Repair", price: "₹1800 onwards" },
      ],
    },
    {
      title: "Gas Charging & Cooling Components",
      items: [
        { name: "Gas Charging", price: "₹2800 onwards" },
        { name: "Copper Coil Condenser", price: "₹4000 onwards" },
        { name: "Compressor Replacement", price: "₹4000 onwards" },
        { name: "Expansion Valve Replacement", price: "₹1200 onwards" },
      ],
    },
    {
      title: "Installation Materials",
      items: [
        { name: "Copper Pipe Set (per ft)", price: "₹350" },
        { name: "Wall Stand", price: "₹750" },
        { name: "Fastener Set", price: "₹200" },
        { name: "Drain Pipe Replacement", price: "₹100 per meter" },
      ],
    },
  ],
};

export default acDetailedRateCard;